import { watch } from 'vue'
import { getWindow } from '@/helpers/globals'
import { useGtmVar } from '../gtm/useGtmVar'
import { useMsClarityId } from './useMsClarityId'
import { useScriptTag } from '@vueuse/core'

export function useMsClarity() {
    // return
    const window = getWindow()
    const document = window?.document
    const id = useMsClarityId()

    if (!document || !id) {
        return
    }

    window.clarity =
        window.clarity ||
        (function (...args: any) {
            if (!window.clarity) {
                return
            }

            ;(window.clarity.q = window.clarity.q || []).push(args)
        } as NonNullable<typeof window.clarity>)

    useScriptTag(`https://www.clarity.ms/tag/${id}`, undefined, {
        async: true,
    })

    const customerId = useGtmVar<string>('customer-id')
    const sessionId = useGtmVar<string>('session-id')
    const amazonTraceId = useGtmVar<string>('amazon-trace-id')

    const setClarityVar = (key: string, value: string | undefined) => {
        if (!value) {
            return
        }

        window?.clarity?.('set', key, value)
    }

    watch(
        customerId,
        (newCustomerId) => {
            setClarityVar('customer-id', newCustomerId)
        },
        { immediate: true }
    )

    watch(
        sessionId,
        (newSessionId) => {
            setClarityVar('session-id', newSessionId)
        },
        { immediate: true }
    )

    watch(
        amazonTraceId,
        (newAmazonTraceId) => {
            setClarityVar('amazon-trace-id', newAmazonTraceId)
        },
        { immediate: true }
    )
}
